var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.diff)?_c('Countdown',{staticClass:"text-14px leading-22px flex min-w-80px",attrs:{"time":_vm.diff},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var days = ref.days;
var hours = ref.hours;
var minutes = ref.minutes;
var seconds = ref.seconds;
return [_c('b',{staticClass:"font-rubik font-medium"},[_vm._v(" "+_vm._s(days * 24 + hours)+":"+_vm._s(String(minutes).padStart(2, '0'))+":"+_vm._s(String(seconds).padStart(2, '0'))+" ")])]}}],null,false,3654470675)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }